<template>
  <InlineList
      :items="meta"
      v-slot="{ item: groupItem }"
    >
    <InlineList
      v-if="Array.isArray(groupItem)"
      :items="groupItem"
      separator="comma"
      v-slot="{ item }"
    >
      <span
        v-if="noLinks"
        v-text="item.title"
      />
      <LinkOrText v-else :item="item" />
    </InlineList>
    <span
      v-else-if="noLinks"
      v-text="groupItem.title"
    />
    <LinkOrText v-else :item="groupItem" />
  </InlineList>
</template>

<script>

import InlineList from 'src/components/InlineList/InlineList.vue';
import LinkOrText from 'src/components/LinkOrText/LinkOrText.vue';

export default {
  name: 'VacancyMeta',

  components: {
    InlineList,
    LinkOrText,
  },
  
    props: {
      vacancy: {
        type: Object,
        required: true,
      },
      noLinks: Boolean,
    },
    
    computed: {
      // eslint-disable-next-line complexity
      meta() {
        const { location, locations, employment, remoteWork } = this.vacancy;

        const res = [];

        if (locations) {
          res.push(locations);
        } else if (location) {
          res.push(location);
        }

        if (employment) {
          res.push({
            title: employment === 'part_time' ? 'Неполный рабочий день' : 'Полный рабочий день'
          });
        }

        if (remoteWork) {
          res.push({
            title: 'Можно удалённо'
          });
        }

        return res;
      },
    }
}
</script>
